__turbopack_context__.v({
  "AudioPlayer": "M5LVva_AudioPlayer",
  "AudioPlayer__Download": "M5LVva_AudioPlayer__Download",
  "AudioPlayer__Player": "M5LVva_AudioPlayer__Player",
  "AudioPlayer__Title": "M5LVva_AudioPlayer__Title",
  "AudioPlayer__Type": "M5LVva_AudioPlayer__Type",
});
